import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'cropped-text',
  templateUrl: './cropped-text.component.html',
  styleUrls: ['./cropped-text.component.scss']
})
export class CroppedTextComponent extends BaseComponent implements OnChanges {
  @ViewChild('viewedText') viewedText: ElementRef<HTMLSpanElement>;
  @ViewChild('croppedText') croppedText: ElementRef<HTMLSpanElement>;
  @Input() text: string = '';

  ngOnChanges({ text }: SimpleChanges): void {
    if (text?.currentValue || text?.previousValue) {
      this._changeDetectorRef.detectChanges();
    }
  }

  shouldShowTooltip(): boolean {
    return (this.croppedText?.nativeElement?.offsetWidth ?? 0) < (this.viewedText?.nativeElement?.offsetWidth ?? 0);
  }
}
